import {
  forwardRef,
  AvatarGroup as ChakraAvatarGroup,
  type AvatarGroupProps as ChakraAvatarGroupProps,
} from '@chakra-ui/react-v2';
import { OverrideProperties } from 'type-fest';

import { AvatarGroupSize } from './types';

export type AvatarGroupProps = OverrideProperties<
  ChakraAvatarGroupProps,
  {
    size?: AvatarGroupSize;
  }
>;

export const AvatarGroup = forwardRef<AvatarGroupProps, 'div'>((props, ref) => (
  <ChakraAvatarGroup spacing="-0.5rem" {...props} ref={ref} />
));
AvatarGroup.displayName = 'AvatarGroup';
